import { BillboardButton, Expander, ExpanderContent, ExpanderHeader } from '@fs/zion-ui'
import { ContentDelete } from '@fs/zion-icon'
import React from 'react'

export default function ExpandableInput({ fieldEl, displayLabel, checkboxEl, onDelete, removeText, testId }) {
  return (
    <Expander initiallyOpen>
      <ExpanderHeader>{displayLabel}</ExpanderHeader>
      <ExpanderContent>
        {fieldEl}
        {checkboxEl}
        <BillboardButton
          data-testid={`delete-${testId}`}
          color="red"
          Icon={ContentDelete}
          emphasis="low"
          onClick={onDelete}
        >
          {removeText}
        </BillboardButton>
      </ExpanderContent>
    </Expander>
  )
}
